import AppApi from '@app/api/index';

export interface AuditLogItem {
  id: number;
  userId: number | null;
  userName: string | null;
  entityType: string;
  entityId: number | null;
  entityName: string | null;
  action: string;
  fieldName: string | null;
  oldValue: string | null;
  newValue: string | null;
  details: string | null;
  page: string | null;
  createdAt: string;
}

export interface AuditLogsPage {
  items: AuditLogItem[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface AuditLogQuery {
  page?: number;
  limit?: number;
  entityType?: string;
  entityId?: number;
  dateFrom?: string;
  dateTo?: string;
}

export default class AuditLogApi {
  constructor(private readonly api: AppApi) {}

  getLogs(params?: AuditLogQuery): Promise<AuditLogsPage> {
    return this.api.client.get<null, AuditLogsPage>('/audit-logs', { params });
  }
}
